class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    if (this.dataset.url) {
      new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const miniCart = document.getElementById('mini-cart');
        const sectionHTML = this.getSectionInnerHTML(html, '.shopify-section');

        if (miniCart && sectionHTML) {
          miniCart.innerHTML = sectionHTML;
        }
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    if (!this.drawer) return;

    const detailsElement = this.drawer.querySelector('details');
    if (!detailsElement) return;

    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    const updates = this.getSectionsToRender().reduce((acc, section) => {
      const target = document.getElementById(section.id);
      const sectionHTML = parsedState.sections && parsedState.sections[section.id];
      if (!target || !sectionHTML) return acc;
      const innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      if (innerHTML) acc.push({ target, innerHTML });
      return acc;
    }, []);

    requestAnimationFrame(() => {
      updates.forEach(({ target, innerHTML }) => {
        target.innerHTML = innerHTML;
      });
      this.open();
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';

    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return element ? element.innerHTML : '';
  }
}

if (!customElements.get('mini-cart')) {
  customElements.define('mini-cart', MiniCart)
}
